import React, {useState} from 'react';
import './fpComp.scss';
import PasswordInput from './passwordInput';
import {useToast} from '../../../../helpers/commonFunction';
import {Http} from '../../../../helpers/axois';
import axios from 'axios';
import {APIURL} from '../../../../constant/common';
import {useHistory} from 'react-router';

function ResetPassword() {
    const [ newPassword, setNewPassword ] = useState('')
    const [ confirmPassword, setConfirmPassword ] = useState('');
    const [ enableValidation, setEnableValidation ] = useState(false);
    const [ inValidPassword, setInValidPassword ] = useState(false);
    const [ passwordMismatch, setPasswordMismatch ] = useState(false);
    const {SuccessToast, ErrorToast} = useToast();
    const history = useHistory();

    // ---------------------passsword validation ---------------------------------
    const isBetween_8_to_40 = newPassword.length >= 8 && newPassword.length <= 40;
    const hasUpperCase = /[A-Z]/.test(newPassword);
    const hasLowerCase = /[a-z]/.test(newPassword);
    const hasSpecialCharacter = /[!@#$%^&*()_+{}[\]:;<>,.?~-]/.test(newPassword);
    const hasNumber = /\d/.test(newPassword);
    const hasNoSpaces = !newPassword.includes(' ');
    // *****************************************************************************

    function passwordValidation() {
        return (
            <div className="passwordValidation">
                <div className="mustContain" >Must Contain</div>
                <div className={`commonCondition-style ${hasUpperCase ? "conditionOk-style" : "conditionNotOk-style"}`} >1 upper case letter</div>
                <div className={`commonCondition-style ${hasLowerCase ? "conditionOk-style" : "conditionNotOk-style"}`} >1 lower case letter</div>
                <div className={`commonCondition-style ${hasNumber ? "conditionOk-style" : "conditionNotOk-style"}`}>1 number</div>
                <div className={`mt-1 commonCondition-style ${isBetween_8_to_40 ? "conditionOk-style" : "conditionNotOk-style"}`} >8 characters</div>
                <div className={`mt-1 commonCondition-style ${hasSpecialCharacter ? "conditionOk-style" : "conditionNotOk-style"}`} >1 special character</div>
            </div>
        )
    }

    async function handleSubmit() {
        if (newPassword === confirmPassword) {
            if (isBetween_8_to_40 && hasUpperCase && hasLowerCase && hasSpecialCharacter && hasNumber && hasNoSpaces) {
                const emailId = localStorage.getItem('resetPassword_emailId');
                const token = localStorage.getItem('resetPassword_token');
                try {
                    const response = await axios.post(`${APIURL}email/${emailId}/resetPassword`, {newPassword}, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    if (response.data.status === 200) {
                        SuccessToast("Password Updated Successfully!")
                        localStorage.removeItem('resetPassword_token')
                        localStorage.removeItem('resetPassword_emailId')
                        history.push('/forgotPassword/successMessage')
                    } else {
                        ErrorToast("Something unexpected happened, try again later")
                    }
                } catch (err: any) {
                    localStorage.removeItem('resetPassword_token')
                    localStorage.removeItem('resetPassword_emailId')
                    ErrorToast(err.message || "Something unexpected happened, try again later")
                    history.push('/forgotPassword/failureMessage')
                }
            } else {
                setInValidPassword(true);
                ErrorToast("Password does not meet its criteria!")
            }
        } else {
            setPasswordMismatch(true)
            ErrorToast("Please make sure your passwords match!")
        }
    }


    return (
        <div className='resetPassword w-full'>
            <div className='title' >Reset Your Password</div>
            <div style={{marginTop: "51px", width: "369px"}} className='flex flex-col align-items-start'>
                <div className='newPass-title' >New Password</div>
                <PasswordInput
                    onChange={(e) => {
                        setNewPassword(e.target.value);
                        setEnableValidation(true)
                    }}
                    onBlur={() => {newPassword === "" && setEnableValidation(false)}}
                    value={newPassword}
                    placeholder='New Password *'
                />
            </div>
            {enableValidation && passwordValidation()}
            <div style={{marginTop: "30px", width: "369px"}} className='flex flex-col align-items-start'>
                <div className='newPass-title' >Confirm New Password</div>
                <PasswordInput
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    value={confirmPassword}
                    placeholder='Confirm New Password *'
                />
                {passwordMismatch && <div className="mt-1 font-normal" style={{fontSize:"12px", marginLeft: "10px", color: "#E40303"}} >Please make sure your password match.</div>}
                {inValidPassword && <div className="mt-1 font-normal" style={{fontSize:"12px", marginLeft: "10px", color: "#E40303"}} >Password should meet all its criteria.</div>}
            </div>
            <div style={{marginTop: "40px"}} >
                <button onClick={handleSubmit} className='submitBtn' >Submit</button>
            </div>
        </div>
    )
}

export default ResetPassword;